import { render } from "./Index.vue?vue&type=template&id=4924b985&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4924b985&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=4924b985&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3012382476/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4924b985"]])

export default __exports__